import React, { useState } from 'react';
import QuizzOption from "./QuizzOption";

const QuizzQuestion = ({ id, question, options, onOptionSelect, selectedOptionId }) => {

    return (
        <div className="flex flex-col items-center">
            <h2 className="flex items-end text-32 md:text-28 xs:text-20 min-h-92 md:min-h-82 sm:min-h-0 text-primary font-bold leading-sm pb-12 text-center max-w-970 ">{question}</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="170" height="31" viewBox="0 0 170 31">
                <g stroke="#000" fill="none" fillRule="evenodd">
                    <path d="M0 1h64.819C75.963 1 85 9.946 85 20.986V30M170 1h-64.819C94.037 1 85 9.985 85 21.073V31"/>
                </g>
            </svg>
            <div className="flex w-full mt-10 items-center justify-center min-h-40vh sm:min-h-47vh">
                <div className={`w-full flex flex-wrap justify-center sm:justify-start${options.length === 5 ? " max-options" : ""}${!options[0].image ? " sm:max-w-554 w-full-16 -mx-8 sm:mx-0" : " xs:max-w-340 w-full-40 -mx-20 md:w-full-28 md:-mx-14 sm:w-full-20 sm:-mx-10"} `}>
                    {options.map(option =>
                        <QuizzOption 
                            key={option.id} 
                            {...option} 
                            onOptionSelect={onOptionSelect}
                            checked={selectedOptionId === option.id} 
                            selectedOptionId={selectedOptionId}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuizzQuestion;

